import { render, staticRenderFns } from "./GrcDocUtils.vue?vue&type=template&id=16bf84d2&scoped=true&"
import script from "./GrcDocUtils.vue?vue&type=script&lang=js&"
export * from "./GrcDocUtils.vue?vue&type=script&lang=js&"
import style0 from "./GrcDocUtils.vue?vue&type=style&index=0&id=16bf84d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf84d2",
  null
  
)

export default component.exports